<script>
  import About from "./About.svelte";
  import Questions from "./Questions.svelte";
  import Codes from "./Codes.svelte";
  import Router from "svelte-spa-router";

  const routes = {
    // Exact path
    "/": Questions,

    // Using named parameters, with last being optional
    // '/author/:first/:last?': Author,

    // // Wildcard parameter
    // '/book/*': Book,
    // Wildcard parameter
    "/about": About,
    "/codes": Codes,

    // Catch-all
    // This is optional, but if present it must be the last
    // '*': NotFound,
  };
</script>

<!-- <button on:click={() => makeCodes(10000)}>codsfes</button> -->
<!-- <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bulma@0.9.3/css/bulma.min.css"
/> -->

<Router {routes} />

<!-- <Questions></Questions> -->
